import { Component, AfterViewInit, EventEmitter, OnInit, Output, ElementRef, ViewChild, Inject } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Observable, Subscriber } from 'rxjs';
import { UmsService } from '../ums.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { PdfviewerComponent } from '../pdfviewer/pdfviewer.component';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { AlertboxComponent } from '../alertbox/alertbox.component';
import { ModalpopService } from '../modalpop.service';
import { element } from 'protractor';
import { HttpErrorResponse } from '@angular/common/http';

@Component({
  selector: 'app-receipt',
  templateUrl: './receipt.component.html',
  styleUrls: ['./receipt.component.scss']
})
export class ReceiptComponent implements OnInit {
  FeeData: any;
  FeesData: any[];
  constructor(private fb: FormBuilder,
    public umsService: UmsService,public dialogRef1: MatDialogRef<ReceiptComponent>,
    public dialog: MatDialog, private modalPopupService: ModalpopService,
    private spinner: NgxSpinnerService,@Inject(MAT_DIALOG_DATA) public data: any,
   ) {  }
  // constructor( ) { }

  ngOnInit(): void {
    this.prepopulation();
  }

  prepopulation() {
    this.FeesData = []
    this.spinner.show();
    const payload = {};
    // payload['TemplateCode'] =  this.tempCo;
      payload['FeeTemplateCode'] = this.data.TemplateCode
      payload['StuId'] =   this.data.StuId
      payload['FeeHistory'] =  0;
    this.umsService.getSearchFeeDetails(payload).subscribe((res) => {
      this.FeesData = res.data
      res.data.forEach(element => {
        
      });
      this.spinner.hide();
      
        });
      }
   
 

}
